import * as types from "./types";

export function fetchFRRecoveryPointsStart(clientUUID, params) {
  return {
    type: types.FETCH_FR_RECOVERY_POINTS_START,
    clientUUID,
    restoreType: params.type,
    scheduleUUID: params.scheduleUUID,
    params
  };
}

export function fetchFRRecoveryPointsSuccess(points, params) {
  return {
    type: types.FETCH_FR_RECOVERY_POINTS_SUCCESS,
    points,
    params
  };
}

export function fetchFRRecoveryPointsFailure(data, params) {
  return {
    type: types.FETCH_FR_RECOVERY_POINTS_FAILURE,
    data,
    params
  };
}

export function updateFRRecoveryPointSuccess(points) {
  return {
    type: types.UPDATE_FR_RECOVERY_POINT_SUCCESS,
    points
  };
}

export function changeFRRecoveryPoint(scheduleUUID) {
  return {
    type: types.CHANGE_FR_RECOVERY_POINT,
    scheduleUUID
  };
}

export function clearFileRestore() {
  return {
    type: types.CLEAR_FILE_RESTORE
  };
}

export function fetchFilesStart(params) {
  return {
    type: types.FETCH_FILES_START,
    params
  };
}

export function fetchFilesSuccess(files, params) {
  return {
    type: types.FETCH_FILES_SUCCESS,
    files,
    params
  };
}

export function fetchFilesFailure(data) {
  return {
    type: types.FETCH_FILES_FAILURE,
    data
  };
}

export function toggleSelectAllFiles() {
  return {
    type: types.TOGGLE_SELECT_ALL_FILES
  };
}

export function toggleFileSelection(id) {
  return {
    type: types.TOGGLE_FILE_SELECTION,
    id
  };
}

export function toggleShiftFileSelection(id, filesList) {
  return {
    type: types.TOGGLE_SHIFT_FILE_SELECTION,
    id,
    filesList
  };
}

export function initiateRestore(data) {
  return {
    type: types.INITIATE_RESTORE,
    data
  };
}

export function patternSearch(search) {
  return {
    type: types.PATTERN_SEARCH_START,
    search
  };
}

export function changeSearch(searchPattern, loading) {
  return {
    type: types.CHANGE_SEARCH,
    searchPattern,
    loading
  };
}

export function downloadRestoreFilesStart(params, clientUUID, serverIPAddress) {
  return {
    type: types.DOWNLOAD_RESTORE_FILES_START,
    params,
    clientUUID,
    serverIPAddress
  };
}

export function storeRequestParams(params) {
  return {
    type: types.STORE_REQUEST_PARAMS,
    params
  };
}

export function populateUpdatedVolumesFR(client) {
  return {
    type: types.POPULATE_UPDATED_VOLUMES_FR,
    client
  };
}
export function fetchUpdatedVolumesFR(clientUUID, sourceClientUUID) {
  return {
    type: types.FETCH_UPDATED_VOLUMES_FR,
    clientUUID,
    sourceClientUUID
  };
}

export function removeRestoreURLLoader(fileId) {
  return {
    type: types.REMOVE_RESTORE_URL_LOADER,
    fileId
  };
}

export function setDisableRestore(bool) {
  return {
    type: types.DISABLE_RESTORE,
    bool
  };
}

export function enumFolder(data) {
  return {
    type: types.ENUM_FOLDER,
    data: { clientUUID: data.clientUUID, path: data.path },
    name: data.name
  };
}

export function enumFolderResponse(data) {
  return {
    type: types.ENUM_FOLDER_RESPONSE,
    data
  };
}

export function createFolder(data) {
  return {
    type: types.CREATE_FOLDER,
    data
  };
}

export function createFolderResponse(data) {
  return {
    type: types.CREATE_FOLDER_RESPONSE,
    data
  };
}

export function createFolderPop(bool) {
  return {
    type: types.CREATE_FOLDER_POP,
    bool
  };
}

export function selectCustomPath(name) {
  return {
    type: types.SELECT_CUSTOM_PATH,
    name
  };
}

export function setRestoreLocation(location) {
  return {
    type: types.SET_RESTORE_LOCATION,
    location
  };
}

export function confirmCustomPath() {
  return {
    type: types.CONFIRM_CUSTOM_PATH
  };
}

export function downloadRestoreISOStart(client) {
  return {
    type: types.DOWNLOAD_RESTORE_ISO_START,
    client
  };
}

export function changeFRTargetMachine(client) {
  return {
    type: types.CHANGE_FILE_RESTORE_TARGET_MACHINE,
    client
  };
}
